<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 mb-2 empl-tptxt">
              <h3>New Task</h3>
            </div>
            <div class="col-12 col-md-6">
              <form [formGroup]="createGovernmentBusinessForm">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <app-category-selector
                      [module]="module"
                      (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Task Name <sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Task Name Select"
                        formControlName="name"
                        [ngClass]="{
                          'is-invalid':
                            f[this.NAME_CONTROL_NAME] &&
                            f[this.NAME_CONTROL_NAME].errors &&
                            f[this.NAME_CONTROL_NAME].touched
                        }"
                        (change)="onTaskNameSelectChange($event.target.value)">
                        <option [disabled]="true" selected value="">Select Name</option>
                        <option
                          *ngFor="let governmentBusinessTaskType of governmentBusinessTaskTypesForCategory"
                          value="{{ governmentBusinessTaskType?.code }}">
                          {{ governmentBusinessTaskType?.label }}
                        </option>
                      </select>
                      <app-validation
                        field="name"
                        [form]="createGovernmentBusinessForm"
                        [error]="{ required: 'This is a mandatory field, Kindly select Task Name' }"></app-validation>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Department Name <sup>*</sup></label>
                      <input type="text" class="form-control" formControlName="department" />
                      <app-validation
                        field="department"
                        [form]="createGovernmentBusinessForm"
                        [error]="{
                          required: 'This is a mandatory field, Please enter Department name',
                          minLength: 'Department Name should have a minimum of 5 characters',
                          maxLength: 'Department Name should not exceed 30 characters'
                        }">
                      </app-validation>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Office Name <sup>*</sup></label>
                      <input type="text" class="form-control" formControlName="office" />
                      <app-validation
                        field="office"
                        [form]="createGovernmentBusinessForm"
                        [error]="{
                          required: 'This is a mandatory field, Please enter Office name',
                          minLength: 'Office Name should have a minimum of 5 characters',
                          maxLength: 'Office Name should not exceed 30 characters'
                        }">
                      </app-validation>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Task Type <sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Task Type Select"
                        formControlName="type"
                        [ngClass]="{
                          'is-invalid':
                            f[GOV_BUSINESS_TASK_TYPE_CONTROL_NAME] &&
                            f[GOV_BUSINESS_TASK_TYPE_CONTROL_NAME].errors &&
                            f[GOV_BUSINESS_TASK_TYPE_CONTROL_NAME].touched
                        }">
                        <option [disabled]="true" selected value="">Select Task Type</option>
                        <option
                          *ngFor="let governmentBusinessTaskType of governmentBusinessTaskTypesForTask"
                          [value]="governmentBusinessTaskType">
                          {{ governmentBusinessTaskType }}
                        </option>
                      </select>
                      <app-validation
                        field="type"
                        [form]="createGovernmentBusinessForm"
                        [error]="{ required: 'This is a mandatory field, Kindly select Task Type' }"></app-validation>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Section Reference</label>
                      <input type="text" class="form-control" formControlName="sectionReference" />
                      <app-validation
                        field="sectionReference"
                        [form]="createGovernmentBusinessForm"
                        [error]="{
                          minLength: 'Section Reference should have a minimum of 5 characters',
                          maxLength: 'Section Reference should not exceed 40 characters'
                        }">
                      </app-validation>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Response Due by</label>
                      <input
                        type="date"
                        class="form-control"
                        onFocus="this.showPicker()"
                        formControlName="responseDueDatetime" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <app-assign-to-selector
                      (selectedValueChange)="handleAssignToSelectedValue($event)"></app-assign-to-selector>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <app-company-selector
                        (selectedValueChange)="handleCompanySelectedValue($event)"></app-company-selector>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Location <sup>*</sup></label>
                      <select class="form-select" aria-label="Default select example" formControlName="location">
                        <option [disabled]="true" selected value="">Select Location</option>
                        <option *ngFor="let location of locationOptions | keyvalue" [value]="location.key">
                          {{ location.value }}
                        </option>
                      </select>
                      <app-validation
                        field="location"
                        [form]="createGovernmentBusinessForm"
                        [error]="{ required: 'This is a mandatory field, Kindly select location' }">
                      </app-validation>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <label for="exampleFormControlTextarea1" class="form-label">Description <sup>*</sup></label>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="4"
                        formControlName="description"
                        [ngClass]="{ 'is-invalid': f['description'].errors && f['description'].touched }"></textarea>
                      <app-validation
                        field="description"
                        [form]="createGovernmentBusinessForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly add description',
                          minLength: 'Description should have a minimum of 5 characters',
                          maxLength: 'Description should not exceed 5000 characters'
                        }">
                      </app-validation>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                        formControlName="addToCalendar" />
                      <label class="form-check-label" for="flexCheckChecked">Add this activity to my Calendar</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-12 col-md-6">
              <p>Upload Documents</p>
              <app-multiple-file-selector
                [maxAllowedSizeInMB]="2"
                [enableMultiSelect]="true"
                [allowedTypes]="[
                  'application/pdf',
                  'image/jpeg',
                  'image/png',
                  'application/msword',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'message/rfc822',
                  'application/vnd.ms-excel.sheet.macroenabled.12'
                ]"
                (chooseFiles)="handleFileInput($event)"
                (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>
              <div id="images-show"></div>
            </div>
            <div class="col-12 d-flex justify-content-end acvtypglastbtn">
              <button type="button" class="btn-actvtytp" (click)="saveAndExit()">SAVE & EXIT</button>
              <button type="button" class="btn-discard" (click)="exit()">CANCEL</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
